import WorkflowService from '@/services/api/workflows.services'

const state = () => ({
  workflows: [],
  workflow: {
    id: null,
    name: '',
    nodes: [],
    edges: [],
  },
})

const getters = {
  getWorkflowList: (state) => state.workflows,
  getWorkflow: (state) => state.workflow,
}

const mutations = {
  SET_WORKFLOWS(state, payload) {
    state.workflows = payload
  },
  SET_WORKFLOW(state, payload) {
    state.workflow = payload
  },
}

const normalizeWorkflow = (data = {}) => ({
  id: data.id ?? null,
  name: data.name ?? '',
  nodes: Array.isArray(data.nodes) ? data.nodes : [],
  edges: Array.isArray(data.edges) ? data.edges : [],
})

const actions = {
  async fetchWorkflows({ commit }) {
    const response = await WorkflowService.list()
    const list = Array.isArray(response?.data?.data) ? response.data.data : []
    commit('SET_WORKFLOWS', list)
    return list
  },

  async fetchWorkflowById({ commit }, id) {
    const response = await WorkflowService.getById(id)
    const normalized = normalizeWorkflow(response?.data?.data ?? response?.data ?? {})
    commit('SET_WORKFLOW', normalized)
    return normalized
  },

  async createWorkflow(_, payload) {
    const response = await WorkflowService.create(payload)
    return response?.data?.data ?? response?.data ?? null
  },

  async updateWorkflow(_, { id, data }) {
    const response = await WorkflowService.update(id, data)
    return response?.data?.data ?? response?.data ?? null
  },

  async deleteWorkflow(_, id) {
    await WorkflowService.delete(id)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
